import React from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { Button, Stack, alpha, useTheme, useMediaQuery } from '@mui/material';
import LoginIcon from '@mui/icons-material/Login';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import SearchIcon from '@mui/icons-material/Search';
import DashboardIcon from '@mui/icons-material/Dashboard';

/**
 * Sign in / Register / Query Page / Dashboard actions (no logo — embed in an existing toolbar).
 */
export default function PublicSiteAccessButtons({ active = 'home', barIsLight = false, size = 'medium' }) {
  const theme = useTheme();
  const navigate = useNavigate();
  const compact = useMediaQuery(theme.breakpoints.down('md'));
  const btnSize = size === 'small' || compact ? 'small' : 'medium';

  const goLogin = (entryLabel, redirectPath) => {
    navigate('/login', { state: { from: { pathname: redirectPath }, entryLabel } });
  };

  const navBtnSx = (key) => ({
    textTransform: 'none',
    fontWeight: active === key ? 700 : 500,
    color: barIsLight ? theme.palette.text.primary : '#f1f5f9',
    ...(active === key
      ? {
          bgcolor: barIsLight ? alpha(theme.palette.primary.main, 0.12) : alpha('#fff', 0.14)
        }
      : {})
  });

  return (
    <Stack direction="row" spacing={0.5} flexWrap="wrap" useFlexGap alignItems="center">
      <Button
        color="inherit"
        size={btnSize}
        startIcon={!compact ? <LoginIcon sx={{ color: 'inherit' }} /> : undefined}
        onClick={() => goLogin('Sign in', '/dashboard')}
        sx={navBtnSx('signin')}
      >
        {compact ? 'Sign in' : 'Sign in / Sign up'}
      </Button>
      <Button
        color="inherit"
        size={btnSize}
        startIcon={!compact ? <PersonAddIcon sx={{ color: 'inherit' }} /> : undefined}
        component={RouterLink}
        to="/signup"
        sx={navBtnSx('register')}
      >
        {compact ? 'Register' : 'Register / Signup'}
      </Button>
      <Button
        component={RouterLink}
        to="/query"
        color="inherit"
        size={btnSize}
        startIcon={!compact ? <SearchIcon sx={{ color: 'inherit' }} /> : undefined}
        sx={navBtnSx('query')}
      >
        {compact ? 'Query' : 'Query Page'}
      </Button>
      <Button
        variant="contained"
        size={btnSize}
        startIcon={!compact ? <DashboardIcon /> : undefined}
        onClick={() => goLogin('Dashboard', '/dashboard')}
        sx={{
          textTransform: 'none',
          fontWeight: 700,
          boxShadow: '0 4px 14px rgba(99,102,241,0.35)',
          ...(barIsLight
            ? {}
            : {
                bgcolor: '#6366f1',
                '&:hover': { bgcolor: '#4f46e5' }
              })
        }}
      >
        Dashboard
      </Button>
    </Stack>
  );
}
